<template>
    <div style="background: #f2f2f2;" v-show="show">
        <common-head active="2" state="1"></common-head>

        <div class="info">
            <div class="name">
                {{info.page_name}}
            </div>
            <div class="content" v-html="info.page_content"></div>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import { common_page } from '@/api/common.js';
    export default {
        name: 'page',
        components: {
            commonHead, commonFooter
        },
        data() {
            return {
                info: { page_name: '页面' },
                show: false,
            }
        },
        metaInfo() {
            return {
                title: this.info.page_name + '-' + this.config.site.name,
                meta: [
                    { name: "keywords", content: "" },
                    { name: "description", content: "" },
                    { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                ],
            }
        },
        created() {
            const id = this.$route.query.id;
            this.get_data(id);
        },
        methods: {
            get_data(id) {
                common_page({ id: id ,loading:true}).then(res => {
                    if (res.code == 200) {
                        this.info = res.data;
                        this.show = true;
                    }
                });
            },
        },
    }
</script>
<style scoped>
    .info {
        width: 1300px;
        margin: 0 auto;
        margin-top: 50px;
        margin-bottom: 50px;
        background: #fff;
        padding: 50px 0;
        text-align: center;
    }

    .name {
        text-align: center;
        font-size: 28px;
        font-weight: 700;
        line-height: 100px;
        color: #333;
    }

    .other {
        text-align: center;
        margin-bottom: 30px;
    }

    .other span {
        margin-right: 30px;
        color: #666;
        font-weight: 300;
    }

    .content {
        line-height: 1.5;
        padding: 50px;
    }

    /deep/ .content img {
        max-width: 100%;
    }
</style>